export default [
  {
    name: 'webchat_main',
    path: '/webchat/main',
    meta: {
      title: '웹챗',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "WebchatMain" */ '@/components/webchat/webchat_main') // 웹챗v1
  },
  {
    name: 'chatbot_preview',
    path: '/chatbot/preview',
    meta: {
      title: '챗봇 미리보기',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "ChatbotPreview" */ '@/components/menus/chatbot/chatbot_preview') // 챗봇 미리보기
  },
  {
    name: 'auth_notice',
    path: '/introduction/auth_notice',
    meta: {
      title: '핸드폰 인증 이용 약관 팝업',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "CustomerAuthenticationNotice" */ '@/components/introduction/customer_authentication_notice') // 핸드폰 인증 이용 약관 팝업
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/webchat.js